import { useEffect, useRef, useState } from 'react'

export function useHeight<T extends HTMLElement>() {
  const [height, setHeight] = useState(0)
  const containerRef = useRef<T>(null)

  useEffect(() => {
    const observer = new ResizeObserver((entries) => {
      if (entries[0]) {
        setHeight(entries[0].contentRect.height)
      }
    })

    if (containerRef.current) {
      observer.observe(containerRef.current)
    }

    return () => {
      if (containerRef.current) {
        observer.unobserve(containerRef.current)
      }
    }
  }, [])

  return [height, containerRef] as const
}
